import { Checkbox } from 'primereact/checkbox'
import { useEffect, useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function SafetyThresholdBox(props: { threshold: number; onChange?: (value: boolean) => void }): ReactElement {
  const { t } = useTranslation('shopping', { keyPrefix: 'SafetyThresholdBox' })

  const [acceptAndHide, setAcceptAndHide] = useState(false)

  useEffect(() => {
    const storedValue = localStorage.getItem('fringeThresholdAccept')
    setAcceptAndHide(storedValue === 'true')
    if (props.onChange) {
      props.onChange(storedValue === 'true')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='border-2 p-4'>
      <div className='mb-4 font-semibold'>{t('title')}</div>
      <div dangerouslySetInnerHTML={{ __html: t('message', { FRINGE_THRESHOLD: props.threshold }) }}></div>

      <div className='mt-4'>
        <div className='flex items-center'>
          <Checkbox
            inputId='accept'
            name='accept'
            value='accept'
            onChange={(e) => {
              const checkValue = e.checked ?? false
              setAcceptAndHide(checkValue)
              if (props.onChange) props.onChange(checkValue)
            }}
            checked={acceptAndHide}
          />
          <label htmlFor='accept' className='ml-2'>
            {t('dontShowAgain')}
          </label>
        </div>
      </div>
    </div>
  )
}
